// src/components/CaseStatsPopover.js
import React, { useState, useEffect } from 'react';
import { useCaseLimit } from '../context/CaseLimitContext';

export const CaseStatsPopover = () => {
  const [show, setShow] = useState(false);
  const { caseLimitData, isLoading, fetchCaseLimitData } = useCaseLimit();

  // Fetch data on mount if not already loaded
  useEffect(() => {
    if (!caseLimitData && !isLoading) {
      fetchCaseLimitData();
    }
  }, [caseLimitData, isLoading, fetchCaseLimitData]);

  // Helper to toggle visibility
  const toggle = () => setShow(!show);
  const open = () => setShow(true);
  const close = () => setShow(false);

  // Extract stats from context data
  const stats = caseLimitData?.cases ? {
    totalCases: caseLimitData.cases.totalCases || 0,
    totalHcCases: caseLimitData.cases.totalHighCourtCases || 0,
    totalDcCases: caseLimitData.cases.totalDistrictCourtCases || 0,
    totalOcCases: caseLimitData.cases.totalOtherCourtCases || 0,
    totalScCases: caseLimitData.cases.totalSupremeCourtCases || 0,
  } : null;

  if (!stats) return null;

  return (
    <div
      className="case-stats-popover-wrapper"
      onMouseEnter={open}
      onMouseLeave={close}
      style={{ position: 'relative', display: 'flex', alignItems: 'center', marginLeft: '0px' }}
    >
      {/* The Trigger Icon */}
      <div
        onClick={toggle}
        // style={{ cursor: 'pointer', color: '#1F4B8F', display: 'flex', alignItems: 'center',fontSize:'17px',textDecoration:'' }}
        style={{
          cursor: 'pointer',
          color: '#1F4B8F',
          display: 'flex',
          alignItems: 'center',
          fontSize: '17px',

          borderRadius: '12px',
          fontWeight: '600'
        }}
      >
        {/* <FaInfoCircle size={18} /> */}

        ( {stats.totalCases} )
      </div>

      {/* The Tooltip Dropdown */}
      {show && (
        <div style={{
          position: 'absolute',
          top: '140%', // Pushes it below the icon
          left: '0',
          backgroundColor: 'white',
          border: '1px solid #e2e8f0',
          borderRadius: '8px',
          padding: '15px',
          boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
          zIndex: 1000,
          width: '220px',
          color: '#333'
        }}>
          {/* <div style={{ fontSize: '14px', fontWeight: 'bold', marginBottom: '10px', borderBottom: '1px solid #eee', paddingBottom: '8px', color: '#1F4B8F' }}>
            Total Cases: {stats.totalCases}
          </div> */}

          <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '6px', fontSize: '13px' }}>
            <span>High Court</span>
            <span style={{ fontWeight: '600', backgroundColor: '#eff6ff', color: '#1d4ed8', padding: '2px 8px', borderRadius: '12px' }}>
              {stats.totalHcCases}
            </span>
          </div>

          <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '6px', fontSize: '13px' }}>
            <span>District Court</span>
            <span style={{ fontWeight: '600', backgroundColor: '#f3e8ff', color: '#7e22ce', padding: '2px 8px', borderRadius: '12px' }}>
              {stats.totalDcCases}
            </span>
          </div>

          <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '6px', fontSize: '13px' }}>
            <span>Other Court</span>
            <span style={{ fontWeight: '600', backgroundColor: '#fff7ed', color: '#c2410c', padding: '2px 8px', borderRadius: '12px' }}>
              {stats.totalOcCases}
            </span>
          </div>

          <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '13px' }}>
            <span>Supreme Court</span>
            <span style={{ fontWeight: '600', backgroundColor: '#f0fdf4', color: '#15803d', padding: '2px 8px', borderRadius: '12px' }}>
              {stats.totalScCases}
            </span>
          </div>
        </div>
      )}
    </div>
  );
};